// theme constant
export * from './constants/attendance.constants';
export * from './constants/holiday.constants';
export * from './constants/payroll.constants';
export * from './constants/docusign.constants';

export const gridSpacing = 5;
// export const drawerWidth = 260;
export const drawerWidth = 320;
export const appDrawerWidth = 320;
export const roles = {
    ADMIN: 'ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
    REGIONAL_MANAGER: 'REGIONAL_MANAGER',
    APARTMENT_MANAGER: 'APARTMENT_MANAGER',
    MARKETING_MANAGER: 'MARKETING_MANAGER',
    VISITOR: 'VISITOR'
};

export const propertyStatus = {
    ARCHIEVED: 'ARCHIEVED',
    TRASHED: 'TRASHED',
    DEFAULT: 'DEFAULT'
};

export const archievedStatus = {
    NONE: 'NONE',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
};

export const LeaveTypes = {
    SICK: 'SICK',
    CASUAL: 'CASUAL',
    EARNED: 'EARNED',
    COMPUNSATORY: 'COMPUNSATORY'
};

export const REMARK_TYPE = {
    PERFORMANCE: 'PERFORMANCE',
    CONFLICT: 'CONFLICT'
};

export const REQUEST_TYPE = {
    ATTENDANCE_CORRECTION: 'ATTENDANCE CORRECTION',
    COMPLAINT: 'COMPLAINT'
};

export const USER_REGISTER_TYPE = {
    REGIONAL_MANAGER: 'REGIONAL MANAGER',
    APARTMENT_MANAGER: 'APARTMENT MANAGER',
    MARKETING_MANAGER: 'MARKETING MANAGER'
};

export const PROPERTY_STATUS = {
    UPCOMING: 'UPCOMING',
    AVAILABLE: 'AVAILABLE',
    SOLD: 'SOLD'
};

export const PROPERTY_TYPE = {
    APARTMENT: 'APARTMENT',
    HOUSE: 'HOUSE',
    OFFICE: 'OFFICE',
    SHOP: 'SHOP'
};

export const RENT_TYPE = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    YEARLY: 'YEARLY'
};
